// FLAGS: silent-failure
// The browser's whole view of configuration: `EnvType` is the declared shape, and the exported `env` merges
// the build-time REACT_APP_* values with whatever `window.env` (public/env.js) supplies at runtime.
declare global {
  interface Window {
    env: any;
  }
}

class EnvType {
  BASE_URL: string = "";

  REACT_APP_VERSION: string = "";

  REACT_APP_APPINSIGHTS_CONNECTION_STRING: string = "";

  REACT_APP_API_SUBDOMAIN: string = "";

  REACT_APP_APPLE_CLIENT_ID: string = "";

  REACT_APP_APPLE_REDIRECT_URI: string = "";

  REACT_APP_ANDROID_STORE_URL: string = "";

  REACT_APP_APPLE_STORE_URL: string = "";

  // FLAGS: silent-failure
  // Two credential-named slots on a shape that is entirely browser-readable. Nothing under `src/` reads
  // either — the only consumer is `cypress/plugins/index.ts`, which runs in Node — but every REACT_APP_*
  // value present at build time is inlined by Vite's `define: { processEnv }`, and the release script
  // `pipelines/set env js.ps1` copies every REACT_APP* variable into `window.env` in the static
  // `public/env.js`. So a populated slot here is served to every visitor, with nothing reporting it.
  REACT_APP_GOOGLE_REFRESH_TOKEN: string = "";

  REACT_APP_GOOGLE_CLIENT_ID: string = "";

  // FLAGS: silent-failure
  // The second of those slots; see the note on REACT_APP_GOOGLE_REFRESH_TOKEN above. No committed file sets
  // this one, so today it is an empty declaration rather than a published value.
  REACT_APP_GOOGLE_CLIENT_SECRET: string = "";

  REACT_APP_MICROSOFT_CLIENT_ID: string = "";

  REACT_APP_MICROSOFT_AUTHORITY: string = "";

  REACT_APP_MICROSOFT_REDIRECT_URI: string = "";

  REACT_APP_CHAT_FEATURE_ENABLED: boolean = false;

  REACT_APP_SANITY_PROJECT_ID: string = "";

  REACT_APP_ENGLISH_DOMAIN: string = "";

  REACT_APP_FRENCH_DOMAIN: string = "";

  REACT_APP_DUTCH_DOMAIN: string = "";

  REACT_APP_SPANISH_DOMAIN: string = "";

  REACT_APP_GERMAN_DOMAIN: string = "";

  REACT_APP_GOOGLE_TAG_MANAGER_ID: string = "";

  REACT_APP_HOSTING_ENV: string = "";

  REACT_APP_GIT_COMMIT_HASH: string = "";

  REACT_APP_PWC_CLIENT_ID: string = "";

  REACT_APP_PWC_AUTHORITY: string = "";

  REACT_APP_PWC_REDIRECT_URI: string = "";

  REACT_APP_PHASE_TWO_CLIENT_ID: string = "";

  REACT_APP_PHASE_TWO_REALM: string = "";

  REACT_APP_PHASE_TWO_REDIRECT_URI: string = "";

  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY: string = "";

  REACT_APP_CUSTOMERIO_SITE_ID: string = "";

  REACT_APP_CUSTOMERIO_REGION: string = "";

  REACT_APP_POSTHOG_API_HOST: string = "";

  REACT_APP_POSTHOG_API_KEY: string = "";
}

const env: any =
  typeof window !== "undefined" && window.env
    ? { ...processEnv, ...window.env }
    : processEnv;

const typedEnv = new EnvType();
Object.keys(typedEnv).forEach((key: string) => {
  if (
    typeof env[key] !== "undefined" &&
    typeof env[key] !==
      typeof Object.entries(typedEnv).find(([k]) => k === key)?.[0]
  ) {
    env[key] = JSON.parse(env[key]);
  }
});

export { env };

export const isProduction = () => env.REACT_APP_HOSTING_ENV === "production";
